<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> گزارش عملکرد آزاد </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <!-- فیلتر جستجو -->

    <div [formGroup]="mdl_Search" class="container-fluid row gx-0 gy-0 mt-0">

        <!-- از تاریخ -->

        <div class="col-12 col-md-2">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> از تاریخ </label>

                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                    [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                    <input type="text" formControlName="strSDate" placeholder="از تاریخ"
                        class="form-control text-end p-2" />

                </ng-persian-datepicker>

            </div>


        </div>

        <!-- تا تاریخ -->

        <div class="col-12 col-md-2">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> تا تاریخ </label>

                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                    [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                    <input type="text" formControlName="strEDate" placeholder="از تاریخ"
                        class="form-control text-end p-2" />

                </ng-persian-datepicker>

            </div>

        </div>

        <!-- متحرک -->

        <div class="col-12 col-md-3">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> متحرک </label>

                <ng-select class="custom" [items]="lstCars" bindLabel="strFullName" [multiple]="true"

                    bindValue="strUnitID" [clearable]="true" [closeOnSelect]="false" [placeholder]="'انتخاب کنید'"

                    [notFoundText]="'موردی یافت نشد'" formControlName="lststrUnitID">

                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">

                        <div *ngFor="let item of items | slice:0:1" class="ng-value">

                            <span class="ng-value-label">{{ item.strFullName }}</span>

                            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>

                        </div>

                        <div *ngIf="items.length > 1" class="ng-value">

                            <span class="ng-value-label"> {{ items.length - 1 | faNum }}+ مورد </span>

                        </div>

                    </ng-template>

                </ng-select>


            </div>

        </div>

        <!-- کاربری -->

        <div class="col-12 col-md-2">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> کاربری </label>

                <ng-select class="custom" [items]="lstMobileType" bindLabel="strComment" [multiple]="true"

                    bindValue="tiMobileType" [clearable]="true" [closeOnSelect]="false" [placeholder]="'انتخاب کنید'"

                    [notFoundText]="'موردی یافت نشد'" formControlName="lsttiMobileType">

                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">

                        <div *ngFor="let item of items | slice:0:1" class="ng-value">

                            <span class="ng-value-label">{{ item.strComment }}</span>

                            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>

                        </div>

                        <div *ngIf="items.length > 1" class="ng-value">

                            <span class="ng-value-label"> {{ items.length - 1 | faNum }}+ مورد </span>

                        </div>

                    </ng-template>

                </ng-select>


            </div>

        </div>

        <!-- مبداء -->

        <div class="col-12 col-md-3">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> مبداء </label>

                <ng-select class="custom" [items]="lst_GeoFence" bindLabel="strTitle" [multiple]="true"

                    bindValue="iGeoFence" [clearable]="true" [closeOnSelect]="false" [placeholder]="'انتخاب کنید'"

                    [notFoundText]="'موردی یافت نشد'" formControlName="lstiSGeoFence">

                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">

                        <div *ngFor="let item of items | slice:0:1" class="ng-value">

                            <span class="ng-value-label">{{ item.strTitle | faNum }}</span>

                            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>

                        </div>

                        <div *ngIf="items.length > 1" class="ng-value">

                            <span class="ng-value-label"> {{ items.length - 1 | faNum }}+ مورد </span>

                        </div>

                    </ng-template>

                </ng-select>


            </div>

        </div>

        <!-- مقصد -->

        <div class="col-12 col-md-3">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> مقصد </label>

                <ng-select class="custom" [items]="lst_GeoFence" bindLabel="strTitle" [multiple]="true"

                    bindValue="iGeoFence" [clearable]="true" [closeOnSelect]="false" [placeholder]="'انتخاب کنید'"

                    [notFoundText]="'موردی یافت نشد'" formControlName="lstiDGeoFence">

                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">

                        <div *ngFor="let item of items | slice:0:1" class="ng-value">

                            <span class="ng-value-label">{{ item.strTitle | faNum }}</span>

                            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>

                        </div>

                        <div *ngIf="items.length > 1" class="ng-value">

                            <span class="ng-value-label"> {{ items.length - 1 | faNum }}+ مورد </span>

                        </div>

                    </ng-template>

                </ng-select>


            </div>

        </div>

        <!-- حداقل مدت توقف -->

        <div class="col-12 col-md-2">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> حداقل مدت توقف </label>

                <input oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()" formControlName="iMintPresenceTime" class="form-control text-center p-2" />

            </div>

        </div>

        <!-- حداکثر مدت توقف -->

        <div class="col-12 col-md-2">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> حداکثر مدت توقف </label>

                <input oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()" formControlName="iMaxPresenceTime" class="form-control text-center p-2" />

            </div>

        </div>

        <!-- جستجو -->

        <div class="col-12 col-md-auto position-relative py-md-2 px-md-1">

            <button class="w-100 btn btn-primary" (click)="search_Report()">

                &nbsp; جستجو &nbsp;

            </button>

        </div>

        <!-- تحلیل -->

        <div class="col-12 col-md-auto position-relative py-md-2 px-md-1">

            <button class="w-100 btn btn-warning" (click)="analyze()">

                &nbsp; تحلیل &nbsp;

            </button>

        </div>

        <!-- حذف تحلیل -->

        <div class="col-12 col-md-auto position-relative py-md-2 px-md-1">

            <button class="w-100 btn btn-danger" (click)="remove_Analyze()">

                &nbsp; حذف تحلیل &nbsp;

            </button>

        </div>

        <!-- خروجی اکسل -->

        <div class="col-12 col-md-auto position-relative py-md-2 px-md-1">

            <button class="w-100 btn btn-success" (click)="exportExcel()">

                &nbsp; خروجی اکسل &nbsp;

            </button>

        </div>

    </div>

    <!-- جدول اطلاعات -->

    <div class="border border-2 mt-3 p-2">

        <div class="row gx-2 gy-md-0 gy-3">

            <!-- اینپوت جستجو -->

            <div class="col-12">

                <input class="w-100 form-control" placeholder="جستجو کنید ..." (keyup)="filter_list($event.target)">

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 330px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>

                    <tr class="text-center">

                        <th scope="col" class="">#</th>

                        <th class="col"> عملیات </th>

                        <th class="col"> نام خودرو </th>

                        <th class="col"> کاربری </th>

                        <th class="col"> پلاک </th>

                        <th class="col bg-light"> مبداء </th>

                        <th class="col bg-light"> ورود </th>

                        <th class="col bg-light"> خروج </th>

                        <th class="col bg-light"> حضور </th>

                        <th class="col bg-light-2"> مقصد </th>

                        <th class="col bg-light-2"> ورود به مقصد </th>

                        <th class="col"> مدت سیر </th>

                        <th class="col"> پیمایش </th>

                        <th class="col"> سرعت متوسط </th>

                        <th class="col"> تعداد توقف </th>

                        <th scope="col" class=""> مدت توقف </th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Reports;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <th class="">

                            <!-- <i class="fa fa-stop-circle fa-lg pointer" title="توقف ها" (click)="openRoute_Stops(item)"></i> -->

                            <i class="fa fa-road mx-2 fa-lg pointer" title="مسیر" (click)="open_Location(item)"></i>

                        </th>

                        <td class="text-dark"> {{ item.strFullName | faNum }} </td>

                        <td class="text-dark"> {{ item.strMobileType_strComment | faNum }} </td>

                        <td class="text-dark"> {{ item.strVehicleNo | faNum }} </td>

                        <td class="text-dark bg-light">{{item.strGeoFenceName | faNum}}</td>

                        <td class="text-dark bg-light" dir="ltr">{{item.strFullEnterTime | faNum}}</td>

                        <td class="text-dark bg-light" dir="ltr">{{item.strFullExitTime | faNum}}</td>

                        <td class="text-dark bg-light">{{item.strPresenceTime | faNum}}</td>

                        <td class="text-dark bg-light-2">{{item.strNexFeoFenceName | faNum}}</td>

                        <td class="text-dark bg-light-2" dir="ltr">{{item.strFullEnterNextTime | faNum}}</td>

                        <td class="text-dark">{{item.strTime | faNum}}</td>

                        <td class="text-dark">{{item.fNavigationKM | faNum}}</td>

                        <td class="text-dark">{{item.iAverageKM | faNum}}</td>

                        <td class="text-dark">{{item.iStops | faNum}}</td>

                        <td class="text-dark">{{item.strStopTime | faNum}}</td>

                    </tr>

                </tbody>

            </table>

        </div>

        <div class="row gx-0 gy-0 p-2 bg-secondary">

            <span class="col-md-auto col-12 text-white"> تعداد نیم راهی : {{ lst_Reports.length | faNum }} </span>

            <span class="col-md-auto col-12 text-white mx-md-5"> مدت سیر : {{ totalTime | faNum }} </span>

            <span class="col-md-auto col-12 text-white mx-md-5"> پیمایش : {{ totalTravel | faNum }} </span>

            <span class="col-md-auto col-12 text-white mx-md-5"> تعداد توقف : {{ totalStop | faNum }} </span>

            <span class="col-md-auto col-12 text-white mx-md-5"> مدت توقف : {{ totalStopTime | faNum }} </span>

        </div>

    </div>

</main>